module.exports = __webpack_public_path__ + "img/skills-02c-preview.5a119058.webp";